// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayFooter_draft_graphql = require("../../../__generated__/PropertyWizardRelayFooter_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayFooter_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayFooter_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayFooter_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayFooter_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayFooter_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayFooter_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayFooter_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Footer(props) {
  var goToStep = props.goToStep;
  var goToPreview = props.goToPreview;
  var step = props.step;
  var draft = use(props.draft);
  var lastStep = step === "photosAndFiles";
  var firstStep = step === "keyFacts";
  var goBack = function () {
    var match = draft.draftProperty.propertyType;
    var tmp;
    tmp = step === "description" ? "mlsTiming" : (
        step === "keyFacts" || step === "mlsTiming" ? "keyFacts" : (
            step === "photosAndFiles" ? (
                match === "FOR_SALE" ? "showings" : "mlsTiming"
              ) : "description"
          )
      );
    goToStep(tmp);
  };
  var goNext = function () {
    var match = draft.draftProperty.propertyType;
    var tmp;
    tmp = step === "description" ? (
        match === "FOR_SALE" ? "showings" : "photosAndFiles"
      ) : (
        step === "mlsTiming" ? "description" : (
            step === "keyFacts" ? "mlsTiming" : "photosAndFiles"
          )
      );
    goToStep(tmp);
  };
  return JsxRuntime.jsxs("div", {
              children: [
                lastStep ? JsxRuntime.jsx("div", {}) : JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
                        onClick: (function (param) {
                            goToPreview();
                          }),
                        children: [
                          JsxRuntime.jsx("span", {
                                children: "Preview",
                                className: "block sm:hidden"
                              }),
                          JsxRuntime.jsx("span", {
                                children: "See preview",
                                className: "hidden sm:block"
                              })
                        ]
                      }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs(ButtonsV5.PrimaryButton.make, {
                              onClick: (function (param) {
                                  goBack();
                                }),
                              disabled: firstStep,
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                            icon: "ArrowLeft"
                                          }),
                                      className: "mr-2 hidden md:block"
                                    }),
                                "Back"
                              ]
                            }),
                        lastStep ? JsxRuntime.jsxs(ButtonsV5.PrimaryButton.make, {
                                onClick: (function (param) {
                                    goToPreview();
                                  }),
                                children: [
                                  "Preview",
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                              icon: "ArrowRight"
                                            }),
                                        className: "ml-2 hidden md:block"
                                      })
                                ]
                              }) : JsxRuntime.jsxs(ButtonsV5.PrimaryButton.make, {
                                onClick: (function (param) {
                                    goNext();
                                  }),
                                disabled: lastStep,
                                children: [
                                  "Next",
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                              icon: "ArrowRight"
                                            }),
                                        className: "ml-2 hidden md:block"
                                      })
                                ]
                              })
                      ],
                      className: "flex flex-row space-x-2"
                    })
              ],
              className: "flex flex-row justify-between"
            });
}

var make = PropertyWizardRelay__Footer;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
